import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()
export const getUSerCredits = async (usuario_cognito?: string): Promise<number> => {
    try {
        auth = getAuthState()

         const body = usuario_cognito
            ? { usuario_cognito: usuario_cognito }
            : {};
        
        const response = await fetch(` https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/userCredit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify(body),
        });
        const data = await response.json();
        return data.body.creditos

    } catch (error) {
        console.error('Error fetching files:', error);
        return -2;
    }
};